import LayoutActividad from "../../../components/LayoutActividad";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ImagenMapa from "../../../images/modulo14/mapalenguas.png";

import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad1Actividad1.mp3";

const Actividad2 = () => {
  const infoUnidad = modulo14.content[0];
  const infoAct = modulo14.content[0].activities[0];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title:
        modulo14.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${infoUnidad.name}: ${modulo14.content[0].activities[1].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[1].path}`,
    titlePrev: modulo14.title,
    linkPrev: modulo14.url,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      {" "}
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>
      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              Casi todos los peruanos hablamos español o castellano. Pero muchos
              peruanos también hablamos otras lenguas que son originarias de
              nuestro país.
            </li>
            <li>
              No conocemos exactamente cuántas lenguas hay en el Perú. Este mapa
              nos ofrece una aproximación a ello.
            </li>
            <li>
              Observa el mapa y, con tu profesor, profesora o familiar, lee el
              nombre de las lenguas originarias de nuestro país que conocemos.
            </li>
          </ul>
        </div>
      </div>
      <div className="col-md-12">
        <img src={ImagenMapa} className="img-fluid" alt="Mapas" />
        <div className="img-capture">
          <p>
            <small>
              (Tomado de Ministerio de Educación (2014). Memoria del Seminario
              Internacional Educación Matemática en Contextos de Diversidad
              Cultural y Lingüística. Lima: Ministerio de Educación).
            </small>
          </p>
        </div>
      </div>
      <GuiaDocente>
        <ul>
          <li>
            Explique que trabajarán el tema de la diversidad
            lingüística del país. Reconocer su existencia resulta clave para la
            convivencia entre todos los peruanos. Empezarán trabajando con la
            observación de imágenes con el fin de dar información sobre la
            diversidad lingüística del Perú.
          </li>
          <li>
            Lea la primera indicación: Casi todos los peruanos hablamos español
            o castellano. Pero muchos peruanos también hablamos otras lenguas
            que son originarias de nuestro país. Explique el
            significado de “lenguas originarias”. Puede, por ejemplo,
            mencionarles lo siguiente:
            <ul>
              <li>
                <i>
                  “Se denomina lenguas originarias a las lenguas que se hablaban
                  en nuestro territorio antes de la llegada del castellano.
                  Muchas de estas lenguas se han extinguido, pero otras siguen
                  presentes”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Pida que observen la ilustración. Pregunte:
            <ul>
              <li>
                <i>
                  “¿Qué vemos en la ilustración? (Posible respuesta: Un mapa del
                  Perú).
                </i>
              </li>
              <li>
                <i>
                  ¿Cómo está dividido el mapa? (Posible respuesta: El mapa está
                  dividido en los departamentos del Perú).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué se muestra en la leyenda del mapa? (Posible respuesta:
                  Son las lenguas que se hablan en el Perú).”
                </i>
              </li>
            </ul>
          </li>

          <li>
            Sobre la ilustración, puede realizar los siguientes comentarios:
            <ul>
              <li>
                <i>
                  “Los mapas son representaciones planas de una parte de la
                  superficie terrestre. En el caso de la ilustración que tenemos
                  la parte de la tierra que se está representando es el Perú.
                  Además, vemos que en el mapa se mencionan los nombres de los
                  departamentos, los países con los que limita el Perú y algunos
                  de sus ríos. El mapa también nos ofrece una leyenda. En ella
                  se ofrecen los símbolos que aparecen en el mapa. En este mapa
                  hay círculos de colores en los diferentes departamentos. La
                  leyenda nos muestra que cada círculo tiene el nombre de una
                  lengua originaria del Perú. Entonces, para saber qué lengua se
                  habla en un determinado departamento, primero tenemos que
                  ubicar el departamento y ver los colores de los círculos que
                  allí aparecen. Luego, iremos a la leyenda para saber a qué
                  lengua corresponden esos colores. Por ejemplo, ubiquemos el
                  departamento de Ica. Notamos que tiene círculos de un solo
                  color. Cuando buscamos ese color en la leyenda, vemos que se
                  trata del quechua. Así, sabemos que la única lengua originaria
                  que se habla en Ica es el quechua”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea las siguientes indicaciones: No sabemos exactamente cuántas
            lenguas hay en el Perú. Este mapa nos ofrece una aproximación a
            ello. Observa el mapa y, con tu profesor, profesora o familiar, lee
            el nombre de las lenguas originarias de nuestro país que conocemos.
            Cierre la actividad resaltando que la cantidad de lenguas que se
            muestran en el mapa da cuenta de la diversidad lingüística que
            existe en el país.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
